<template>
  <div class="relative" ref="container">
    <div
      class="flex items-center shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight bg-white cursor-pointer focus:outline-none focus:shadow-outline"
      :class="inputClass"
      tabindex="0"
      role="button"
      @click="isOpen = !isOpen"
      @keydown.enter="isOpen = !isOpen"
    >
      <span class="text-gray-500 flex-1 mr-2">{{ placeholder }}</span>
      <svg class="w-4 h-4 text-gray-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
      </svg>
    </div>

    <div
      v-if="isOpen"
      class="absolute left-0 right-0 top-full mt-1 shadow border border-gray-300 rounded bg-white z-40 overflow-hidden"
    >
      <div class="max-h-60 overflow-y-auto py-1">
        <button
          v-for="opt in options"
          :key="getOptionKey(opt)"
          type="button"
          class="w-full text-left py-2 px-3 text-gray-700 hover:bg-gray-100 text-sm leading-tight"
          @click="select(opt)"
        >
          {{ getOptionLabel(opt) }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Dropdown',
  props: {
    options: {
      type: Array,
      required: true,
    },
    placeholder: {
      type: String,
      default: 'Выберите',
    },
    label: {
      type: String,
      default: 'label',
    },
    valueKey: {
      type: String,
      default: 'value',
    },
    inputClass: {
      type: String,
      default: '',
    },
  },
  emits: ['select'],
  data() {
    return {
      isOpen: false,
    };
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    handleClickOutside(e) {
      if (this.$refs.container && !this.$refs.container.contains(e.target)) {
        this.isOpen = false;
      }
    },
    getOptionLabel(opt) {
      return typeof opt === 'object' ? opt[this.label] : opt;
    },
    getOptionKey(opt) {
      return typeof opt === 'object' ? (opt[this.valueKey] ?? opt[this.label]) : opt;
    },
    select(opt) {
      const value = typeof opt === 'object' ? opt[this.valueKey] : opt;
      this.isOpen = false;
      this.$emit('select', value, opt);
    },
  },
};
</script>
